module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("市场管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("渠道成交率")])], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 80,
      "show-message": false
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": "16"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "统计周:"
    }
  }, [_c('DatePicker', {
    staticStyle: {
      "width": "220px"
    },
    attrs: {
      "value": _vm.dateRange,
      "format": "yyyy-MM-dd",
      "type": "daterange",
      "clearable": false,
      "placement": "bottom-start",
      "placeholder": ""
    },
    on: {
      "on-change": _vm.onRangeChange
    }
  }), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.exportLoading
    },
    on: {
      "click": _vm.exportData
    }
  }, [_vm._v("导出")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.dimension !== 'category') ? _c('div', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('Button', {
    attrs: {
      "icon": "ios-arrow-back"
    },
    on: {
      "click": _vm.backToCategory
    }
  }, [_vm._v("返回")])], 1) : _vm._e(), _vm._v(" "), _c('Table', {
    ref: "dealTable",
    attrs: {
      "height": _vm.tableHeight,
      "columns": _vm.columns,
      "data": _vm.list,
      "loading": _vm.searchLoading,
      "row-class-name": _vm.rowClassName
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "12px"
    }
  }, [_vm._v("\n    合计：分配 " + _vm._s(_vm.totalAssignCount) + "，累计成交 " + _vm._s(_vm.totalDealCount) + "，累计成交率 " + _vm._s(_vm.formatRate(_vm.totalDealRate)) + "，当前成交 " + _vm._s(_vm.totalCurrentDealCount) + "，当前成交率 " + _vm._s(_vm.formatRate(_vm.totalCurrentDealRate)) + "\n  ")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-68262782","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/market/ChannelDealRate.vue
// module id = 1865
// module chunks = 8